module.exports = __webpack_public_path__ + "static/media/Red_Back.efe55855.svg";